module.exports = __webpack_public_path__ + "img/logo.af8d2d78.svg";